'use client';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SoundState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

// Client-side preference for subtle in-app sound alerts, shared across all apps on this device.
// Default ON; toggled from the shared Settings page.
export const useSoundStore = create<SoundState>()(
  persist(
    (set) => ({
      enabled: true,
      setEnabled: (enabled) => set({ enabled }),
    }),
    {
      name: 'trade-bridge-sound-alerts',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
